import React, { useState } from "react";
import styles from "./AddRoomDetails.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { FaHotel } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const AddRoomDetails = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    roomName: "",
    capacity: "",
    minAgeYrs: "0",
    minAgeMonths: "0",
    maxAgeYrs: "0",
    maxAgeMonths: "0",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = [
      "minAgeYrs",
      "minAgeMonths",
      "maxAgeYrs",
      "maxAgeMonths",
    ].includes(name)
      ? value.replace(/\D/g, "")
      : value;
    setFormData({ ...formData, [name]: cleanedValue });
  };

  const handleSave = () => {
    console.log("Room Details Saved:", formData);
  };

  const handleCancel = () => {
    setFormData({
      roomName: "",
      capacity: "",
      minAgeYrs: "0",
      minAgeMonths: "0",
      maxAgeYrs: "0",
      maxAgeMonths: "0",
    });
  };

  return (
    

      <div className={styles.sectionBox}>
        <div className={styles.sectionHeaderBox}>
          <HeadingAndIcon icon={<FaHotel />} heading="Room Information" />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        <div className={styles.data}>
          <div className={styles.inputsRow}>
            <HeadingAndData
              label="Room Name"
              name="roomName"
              value={formData.roomName}
              onChange={handleChange}
              placeholder="Enter room name"
              required
            />
            <HeadingAndData
              label="Capacity"
              name="capacity"
              value={formData.capacity}
              onChange={handleChange}
              placeholder="Enter room capacity"
              required
            />
          </div>

          <div className={styles.inputsRow}>
            <HeadingAndData
              label="Minimum age (yrs)"
              name="minAgeYrs"
              value={formData.minAgeYrs}
              onChange={handleChange}
            />
            <HeadingAndData
              label="Minimum age (months)"
              name="minAgeMonths"
              value={formData.minAgeMonths}
              onChange={handleChange}
            />
          </div>

          <div className={styles.inputsRow}>
            <HeadingAndData
              label="Maximum age (yrs)"
              name="maxAgeYrs"
              value={formData.maxAgeYrs}
              onChange={handleChange}
            />
            <HeadingAndData
              label="Maximum age (months)"
              name="maxAgeMonths"
              value={formData.maxAgeMonths}
              onChange={handleChange}
            />
          </div>

          <div className={styles.actionsRow}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    
  );
};

export default AddRoomDetails;
